import { useGlobal } from 'reactn';

import ILicenseServer from '../interfaces/ILicenseServer';


export default function useLicenseServers(): [ILicenseServer[], (newValue: ILicenseServer[]) => void] {
  return useGlobal('licenseServers');
}